var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _path8, _g2, _path9, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _circle, _ellipse8, _path0, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#D7C7F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8836_16949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8836_16949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#B396EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.0601C72.2298 83.5012 12.5546 43.3757 6.58582 9.86818L-27.8162 57.6639L55.5728 117.685L107.846 45.0601Z",
    fill: "#6236BD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8836_16949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 8.42178C3.2998 5.11386 5.98141 2.43225 9.28934 2.43225H78.3993C81.7072 2.43225 84.3888 5.11386 84.3888 8.42178V49.9237C84.3888 52.2917 82.4692 54.2114 80.1012 54.2114C77.7332 54.2114 75.8136 56.131 75.8136 58.499V63.0137C75.8136 65.1549 74.6706 67.1331 72.8157 68.2026L46.838 83.1801C44.9853 84.2483 42.7037 84.2476 40.8517 83.1784L14.9121 68.2032C13.0588 67.1333 11.9171 65.1559 11.9171 63.016V58.52C11.9171 56.1404 9.98809 54.2114 7.60848 54.2114C5.22886 54.2114 3.2998 52.2823 3.2998 49.9027V8.42178Z",
    fill: "#FCCE2C"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8836_16949)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0593 24.0068L54.2868 33.6515L48.1488 26.3763L55.6872 22.8373C56.4571 22.4759 57.2942 23.1894 57.0593 24.0068Z",
    fill: "#6236BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7661 16.4488L27.9937 26.0935L37.0581 23.1884L32.5497 16.1864C32.0893 15.4714 31.0011 15.6315 30.7661 16.4488Z",
    fill: "#6236BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7619 49.4538C57.2227 41.4747 44.3889 47.4954 39.9403 51.9001L60.4415 58.3866C60.468 58.0602 67.0034 53.2582 69.7963 51.22C70.4077 50.7738 70.4006 49.8602 69.7619 49.4538Z",
    fill: "#6236BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78912 22.0068C26.6379 28.8548 34.9991 47.9335 35.9447 56.4889L9.19962 39.6916C9.44894 39.3838 6.57461 27.9024 5.40812 23.2957C5.19694 22.4617 5.97585 21.7262 6.78912 22.0068Z",
    fill: "#6236BD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3165,
    cy: 23.7681,
    rx: 18.3165,
    ry: 23.7681,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 61.0696 26.6483)",
    fill: "#8D61E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8836_16949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 21,
    width: 38,
    height: 47
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3165,
    cy: 23.7681,
    rx: 18.3165,
    ry: 23.7681,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 61.0696 26.6483)",
    fill: "#AD8873"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8836_16949)"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2672,
    cy: 23.4863,
    rx: 18.2672,
    ry: 23.4863,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 66.4629 29.7988)",
    fill: "#D7C7F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8836_16949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 16,
    width: 42,
    height: 33
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6608 48.4003C39.8028 47.3328 49.3772 44.4071 55.3872 46.1347L61.1516 26.0814L26.1815 16.0292L20.3705 36.2448C27.1178 38.1843 33.0507 45.3541 34.9728 47.8794C35.3663 48.3964 36.0456 48.6093 36.6608 48.4003Z",
    fill: "#86D1F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8836_16949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6608 48.4003C39.8028 47.3328 49.3772 44.4071 55.3872 46.1347L61.1516 26.0814L26.1815 16.0292L20.3705 36.2448C27.1178 38.1843 33.0507 45.3541 34.9728 47.8794C35.3663 48.3964 36.0456 48.6093 36.6608 48.4003Z",
    fill: "#6236BD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2672,
    cy: 23.4863,
    rx: 18.2672,
    ry: 23.4863,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 66.5908 27.746)",
    fill: "#6236BD"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8686 41.6326L42.8937 38.603L43.8332 35.3348L35.8527 33.0405L34.9133 36.3087L36.7439 41.0269C37.0762 41.8833 38.1347 42.1851 38.8686 41.6326Z",
    fill: "#E37230"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.00994,
    cy: 6.00994,
    rx: 6.00994,
    ry: 6.00994,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 53.0398 31.8938)",
    fill: "#AD8873"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.88879,
    cy: 3.88879,
    rx: 3.88879,
    ry: 3.88879,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 50.415 33.3464)",
    fill: "#FCCE2C"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26257,
    cy: 2.26257,
    rx: 2.26257,
    ry: 2.26257,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 49.6753 33.7559)",
    fill: "#1D262D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.00994,
    cy: 6.00994,
    rx: 6.00994,
    ry: 6.00994,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 41.4885 28.5731)",
    fill: "#AD8873"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.88879,
    cy: 3.88879,
    r: 3.88879,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 38.864 30.0255)",
    fill: "#FCCE2C"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26257,
    cy: 2.26257,
    rx: 2.26257,
    ry: 2.26257,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 38.1238 30.4353)",
    fill: "#1D262D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8836_16949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 4,
    width: 23,
    height: 26
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9332 24.7821C79.2286 24.9898 74.5973 22.5444 72.2323 18.1126C69.9095 13.7601 70.3953 8.65809 73.0579 4.88429C71.2823 4.97984 69.4989 5.45575 67.8266 6.34817C61.7053 9.61481 59.3912 17.2252 62.6578 23.3465C65.9244 29.4678 73.5348 31.7819 79.6561 28.5153C81.4072 27.5808 82.8467 26.2909 83.9332 24.7821Z",
    fill: "#FCCE2C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8836_16949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9332 24.7821C79.2286 24.9898 74.5973 22.5444 72.2323 18.1126C69.9095 13.7601 70.3953 8.65809 73.0579 4.88429C71.2823 4.97984 69.4989 5.45575 67.8266 6.34817C61.7053 9.61481 59.3912 17.2252 62.6578 23.3465C65.9244 29.4678 73.5348 31.7819 79.6561 28.5153C81.4072 27.5808 82.8467 26.2909 83.9332 24.7821Z",
    fill: "#E8BF2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5311 23.1454C81.8266 23.3531 77.1954 20.9076 74.8305 16.476C72.5077 12.1234 72.9935 7.02147 75.6561 3.24768C73.8804 3.3432 72.0968 3.81911 70.4245 4.71157C64.3032 7.97821 61.9891 15.5886 65.2557 21.7099C68.5223 27.8312 76.1327 30.1453 82.254 26.8787C84.0051 25.9442 85.4447 24.6543 86.5311 23.1454Z",
    fill: "#FCCE2C"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8836_16949)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 24.5,
    width: 16,
    height: 45,
    rx: 3.5,
    fill: "white",
    stroke: "#D7C7F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 38L78.5 34L72 38",
    stroke: "#491EA1",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 32L78.5 28L72 32",
    stroke: "#491EA1",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 44L78.5 40L72 44",
    stroke: "#491EA1",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 50L78.5 46L72 50",
    stroke: "#491EA1",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 56L78.5 52L72 56",
    stroke: "#491EA1",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 62L78.5 58L72 62",
    stroke: "#491EA1",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 68L78.5 64L72 68",
    stroke: "#491EA1",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 25,
    width: 15,
    height: 44,
    rx: 3,
    stroke: "#D7C7F6",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8836_16949"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 24,
    width: 17,
    height: 46,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.072186c8c4b5328570b7073ed0df9fb9.svg";
export { ForwardRef as ReactComponent };